// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
import Section from 'components/Section';
// import conditions from 'data/conditions';
import SectionHeader from 'components/SectionHeader';
// import NewsIcon from 'components/NewsIcon';
import topDoc from 'static/images/top-doc-2021.png';
import uroTimes2021 from 'static/images/uro-times-2021.jpg';
import freestyle2022 from 'static/images/freestyle2022.jpg';
import circumsessions from 'static/images/circumsessions.jpg';
import operateWithZen from 'static/images/operate-with-zen.webp';
import backtableUrology from 'static/images/backtable-urology.webp';
import urologyTimes from 'static/images/urology-times.png';

import NewsIcon from 'components/NewsIcon';

// local
import styles from './NewsSection.pcss';
import NewsItem from './NewsItem';

/* eslint-disable max-len */
const NEWS = [{
  title: 'In this podcast Dr. Seideman shares her experience with BackTable Urology, and her advice for dealing with complications as a surgeon.',
  publisher: 'The Anatomy of a Complication: Surgeon Health',
  date: 'May 10, 2022',
  image: backtableUrology,
  url: 'https://www.backtable.com/shows/urology/podcasts/39/the-anatomy-of-a-complication-surgeon-health',
}, {
  title: 'A few years ago, Casey had never run a complete mile. Now she is an outspoken advocate for wellness in the operating room and beyond. In this podcast we tackle small changes and their ability make big impact, how mental preparation promotes a health surgical community, and how, as a surgeon, you can achieve great things you never thought you could do.',
  publisher: 'Operate with Zen: Small Changes for Big Results',
  date: 'May 3, 2022',
  image: operateWithZen,
  url: 'https://podcasts.apple.com/us/podcast/operate-with-zen/id1579495428?i=1000560066866',
}, {
  title: 'How building a social media presence can positively impact your professional development.',
  publisher: 'Urology Times',
  date: 'Mar 25, 2022',
  image: urologyTimes,
  url: 'https://www.urologytimes.com/view/how-building-a-social-media-presence-can-positively-impact-your-professional-development',
}, {
  title: (
    <span>
      { 'Watch Dr. Seideman\'s patients ' }
      <a title={ 'View Sam David\'s Collection' } href={ 'https://ohsufoundation.org/stories/freestyle-2022-sam-david-phelps/' }>{ 'Sam David' }</a>
      { ' and ' }
      <a title={ 'View Maylee\'s Collection' } href={ 'https://ohsufoundation.org/stories/freestyle-2022-maylee-phelps' }>{ 'Maylee' }</a>
      { ' Phelps unveil their exclusive designs for the highly anticipated 2022 Freestyle collection.' }
    </span>
  ),
  publisher: 'Doernbecher Freestyle XVII',
  date: 'Feb 25, 2022',
  image: freestyle2022,
  url: 'https://news.ohsu.edu/2022/02/26/icymi-doernbecher-freestyle-xvii-collection-unveiled-to-international-audience',
}, {
  title: 'Dr. Seideman on the underrepresentation of women in AUA prestigious recognition awards.',
  publisher: 'Urology Times',
  date: 'July 01, 2021',
  image: uroTimes2021,
  url: 'https://www.urologytimes.com/view/dr-casey-seideman-on-underrepresentation-of-women-in-aua-prestigious-recognition-awards',
}, {
  title: 'Award - Top Doctor 2021',
  publisher: 'Portland Monthly',
  date: 'Dec 08, 2020',
  image: topDoc,
  url: 'https://www.pdxmonthly.com/doctors/type/pediatric-urology',
}, {
  title: 'Dr. Seideman discusses gender disparities in pediatric urology.',
  publisher: 'Podcast - Circumsessions',
  date: 'Dec 02, 2020',
  image: circumsessions,
  url: 'https://anchor.fm/circumsessions/episodes/Episode-3---Gender-Disparities-in-Paediatric-Urology-with-Dr--Casey-Seideman-en91dt',
}, {
  title: 'Seizing the moment for change',
  subTitle: 'OHSU, UW urologists energize their profession through national network focused on diversity, equity, inclusion.',
  publisher: 'OHSU',
  date: 'Oct 19, 2020',
  image: 'https://s3.amazonaws.com/cms.ipressroom.com/296/files/20209/5f8dce2b2cfac20df1d81859_Urologists+for+equity/Urologists+for+equity_f0400813-1698-4814-8f95-b55bc7146ac3-prv.jpg',
  url: 'https://news.ohsu.edu/2020/10/19/seizing-the-moment-for-change',
}, {
  title: 'Announcing: Urologists for Equity',
  subTitle: 'A community of urologists who will work together towards achieving equity in our profession.',
  publisher: 'Urologists for Equity',
  date: 'June, 2020',
  image: 'https://freight.cargo.site/w/600/q/75/i/acf3712b5d4e932cb12ce23923c1b032bb30c83cc1fef8ea8190fc3a98e752b6/urologists-for-equity-rectangle-logo-v1.jpg',
  url: 'https://uroequity.org/Open-Letter',
}];
/* eslint-enable max-len */

export default class NewsSection extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
  }
  static defaultProps = {}
  
    
  render() {
    const { className } = this.props;
    const classNames = classnames(className, styles.newsSection);
    
    return (
      <Section id={ 'news' } className={ classNames }>
        <SectionHeader
          className={ styles.header }>
          <div className={ styles.icon }>
            <NewsIcon />
          </div>
          { 'News' }
        </SectionHeader>
        <div className={ styles.items }>
          {
            NEWS.map((news, i) => (
              <NewsItem key={ i } news={ news } />
            ))
          }
        </div>
      </Section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NewsSection/index.jsx